const ITEMS = [
  "Reprises rock endiablées",
  "Toto",
  "Gossip",
  "The Cranberries",
  "Céline Dion",
  "Jean-Jacques Goldman",
  "Fêtes locales",
  "Festivals",
  "100% live",
];

const Marquee = () => (
  <div
    data-testid="marquee-ribbon"
    className="relative overflow-hidden border-y border-amber-500/15 bg-[#09090D] py-6 -rotate-1 scale-[1.02]"
  >
    <div className="flex w-max animate-marquee items-center gap-10">
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center gap-10 shrink-0">
          <span
            className={`font-display text-2xl sm:text-3xl font-bold uppercase tracking-wide whitespace-nowrap ${
              i % 2 === 0 ? "text-zinc-100" : "text-outline"
            }`}
          >
            {t}
          </span>
          <span className="text-amber-500 text-xl">•</span>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
